// Swap / MC are FOW-programme features. Hides the menu entries (and gates the
// pages) for clients who have no active FOW schedule — CIP-only clients.
export default {
    computed: {
        fowClientId() {
            return this.$root.currentUser?.[0]?.crb5c_client?.crb5c_fow_customerid || null;
        },
        // null = unknown yet, true/false once checked for the current client
        fowEligible() {
            const e = this.$store.state.fowEligibility;
            return e && e.clientId && e.clientId === this.fowClientId ? e.eligible : null;
        },
    },
    methods: {
        async ensureFowEligibility() {
            const clientId = this.fowClientId;
            if (!clientId || this.fowEligible !== null) return;
            try {
                const { data } = await this.$root.axios.get('/makeup_sessions/fow-eligibility', {
                    params: { userID: clientId },
                });
                this.$store.commit('setFowEligibility', { clientId, eligible: !!data.fowEligible });
            } catch (e) {
                // Leave unknown (links hidden); the pages themselves still gate server-side.
                console.warn('FOW eligibility check failed', e?.response?.data || e?.message);
            }
        },
    },
};
